"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_use_1 = require("react-use");
const react_2 = require("@osmosys/react");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
exports.OsmosysNetworkConnectionToast = ({ online }) => {
    const [dismissed, toggleDismissed] = react_use_1.useToggle(false);
    const undismiss = online && dismissed;
    react_1.useEffect(() => {
        if (undismiss) {
            toggleDismissed(false);
        }
    }, [undismiss]);
    return (react_1.default.createElement(react_2.OsmosysToast, { isOpen: !dismissed && !online, title: "Network connection issue", icon: pro_solid_svg_icons_1.faGlobeAmericas, color: "danger", onToggle: () => {
            toggleDismissed(true);
        } }, "Could not connect to Osmosys. You may not be connected to the Internet or Osmosys is down."));
};
//# sourceMappingURL=OsmosysNetworkConnectionToast.js.map